import { __assign } from "tslib";
import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import ErrorBoundary from '../../ErrorBoundary';
import retry from '../../utils/webpack/chunkRetry';
var LoadableRedux = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "nft" */
        '../redux/ModuleLoadable');
    });
});
var LoadableNftLinkPopup = lazy(function () {
    return retry(function () {
        return import(
        /* webpackChunkName: "nft" */
        './NftLinkPopup');
    });
});
var LazyNftLinkPopup = function (props) { return (React.createElement(ErrorBoundary, { debugComponent: "LazyNftLinkPopup" },
    React.createElement(Suspense, { fallback: React.createElement(LoadingIndicator, { view: 'llama', withOverlay: true, usePortal: true }) },
        React.createElement(LoadableRedux, null),
        React.createElement(LoadableNftLinkPopup, __assign({}, props))))); };
LazyNftLinkPopup.displayName = 'LazyNftLinkPopup';
export default LazyNftLinkPopup;
//# sourceMappingURL=LazyNftLinkPopup.js.map